import { useUserStore } from '@/stores/user';
import {
  convertAmericanToDecimal,
  roundToFixed2,
  formatDecimalOdds,
  convertAmericanToImpliedProbability,
} from './utils';
import { oddsWithCommission } from './commissionUtils';

/*
Use formatOdds to format odds based on view commission and view odds settings
User formatOdds no commission to format odds on components where even if the user has
view odds with commission on, it does not show with comission
*/

export function signOdds(odds) {
  const n = Number(odds);
  if (!n) return n;
  // if there are american numbers with decimals, it will set n to display only one decimal with its sign only if it doesnt contain .0 otherwise will display the integer part or just display the received value//
  if (n.toString().includes('.') && n.toString().length > 5) {
    if (n.toFixed(1).includes('.0')) {
      return n > 0 ? `+${n.toFixed(0)}` : `${n.toFixed(0)}`;
    } else if (!n.toFixed(1).includes('.0')) {
      return n > 0 ? `+${n.toFixed(1)}` : `${n.toFixed(1)}`;
    }
  }
  return n > 0 ? `+${n}` : `${n}`;
}

function convertOdds(odds, style) {
  if (style === 'decimal') {
    const number = convertAmericanToDecimal(odds);
    return formatDecimalOdds(number);
  } else if (style === 'impliedProbability') {
    const number = convertAmericanToImpliedProbability(odds);
    return roundToFixed2(number);
  }
}

export function formatOdds(
  odds,
  league,
  betType,
  displayDecimal,
  userStore = useUserStore(),
) {
  if (!odds) return '';
  let formattedOdds = odds;

  formattedOdds = oddsWithCommission(
    odds,
    league,
    betType,
    displayDecimal,
    userStore,
  );

  if (userStore.user.oddsFormat === 'decimal') {
    formattedOdds = convertOdds(formattedOdds, 'decimal');
  } else if (userStore.user.oddsFormat === 'impliedProbability') {
    formattedOdds = convertOdds(formattedOdds, 'impliedProbability');
  } else {
    formattedOdds = signOdds(formattedOdds);
  }

  return formattedOdds;
}

export function formatOddsNoCommission(odds) {
  const userStore = useUserStore();
  if (!odds) return '';
  let formattedOdds = odds;

  if (userStore.user.oddsFormat === 'decimal') {
    formattedOdds = convertOdds(formattedOdds, 'decimal');
  } else if (userStore.user.oddsFormat === 'impliedProbability') {
    formattedOdds = convertOdds(formattedOdds, 'impliedProbability');
  } else {
    formattedOdds = signOdds(formattedOdds);
  }
  return formattedOdds;
}

export function formatOddsRounded(
  odds,
  league,
  betType,
  displayDecimal,
  userStore = useUserStore(),
) {
  const formatted = formatOdds(odds, league, betType, displayDecimal, userStore);
  if (typeof formatted === 'string' && /^[+-]/.test(formatted)) {
    const n = parseFloat(formatted);
    if (!isNaN(n)) {
      const rounded = Math.round(n);
      return rounded > 0 ? `+${rounded}` : `${rounded}`;
    }
  }
  return formatted;
}

export function sign(value) {
  const userStore = useUserStore();
  if (userStore.user.oddsFormat === 'decimal') {
    return value;
  }
  return signOdds(value);
}
